module.exports = __webpack_public_path__ + "img/hand-rock.fa73f94c.svg";